module.exports = __webpack_public_path__ + "img/img-404.e90a4a77.png";